<header>
  <h3>Employer Details</h3>
  <fa-icon icon="times" (click)="closeDialog()"/>
</header>
<div class="main-content">
  @if (employer?.logo) {
    <img [ngSrc]="employer.logo ?? ''" [alt]="employer.name ? employer.name + ' logo' : ''" width="30" height="30">
  }
  <h4>{{ employer?.name }}</h4>
  <div class="divider"></div>
  <p>{{ employer?.description }}</p>
  <a rel="noopener" [href]="employer.website" target="_blank">{{ employer?.website }}<span class="sr-only"> (opens in a new tab)</span></a>
</div>
<div class="button-section">
  <button type="button" class="new-connection" (click)="closeDialog()">
    Close
  </button>
</div>
